import "vite/modulepreload-polyfill";

import "@frontend/styles/index.css";

import mobileBar from "@frontend/scripts/components/mobile-bar";
import modal from "@frontend/scripts/components/modal";
import reductionOffer from "@frontend/scripts/pages/reduction-offer";
import reductionRequest from "@frontend/scripts/pages/reduction-request";
import styledForm from "@frontend/scripts/components/styled-form";
import validateForm from "@frontend/scripts/components/validate-form";
import siteHeader from "@frontend/scripts/components/site-header";
import ajaxForm from "@frontend/scripts/components/ajax-form";
import siteAnnouncementBar from "@frontend/scripts/components/site-announcement-bar";
import siteWidget from "@frontend/scripts/components/site-widget";
import pageOverlay from "@frontend/scripts/components/page-overlay";
import slideToggle from "@frontend/scripts/components/slide-toggle";

mobileBar.init();
modal.init();
reductionOffer.init();
reductionRequest.init();
styledForm.init();
validateForm.init();
siteHeader.init();
ajaxForm.init();
siteAnnouncementBar.init();
siteWidget.init();
pageOverlay.init();
slideToggle.init();

document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    document.documentElement.classList.remove("_preload");
  }, 250);
});
